import { DarkModePreferenceSetter } from './darkModeTypes'
import { DarkMode } from './types'

export function updateDarkModeStyles(darkMode: boolean | undefined, applyBackground: boolean = true): void {
  if (typeof window === 'undefined') return

  const htmlElement = document.documentElement

  if (applyBackground) {
    const isDarkModeActive = darkMode === true

    const currentAttr = htmlElement.getAttribute('data-dark-mode')

    if (currentAttr !== isDarkModeActive.toString()) {
      htmlElement.setAttribute('data-dark-mode', isDarkModeActive.toString())

      htmlElement.style.removeProperty('background-color')
      document.body?.style.removeProperty('background-color')
    }
  } else {
    htmlElement.removeAttribute('data-dark-mode')
    htmlElement.style.removeProperty('background-color')
    document.body?.style.removeProperty('background-color')
  }
}

export function syncDarkModeCookie(darkMode: DarkMode, setPreference?: DarkModePreferenceSetter): void {
  if (!setPreference) return

  const preference = darkMode === DarkMode.System ? 'system' : darkMode === DarkMode.Dark ? 'dark' : 'light'
  setPreference(preference)
}
